import { useState, useEffect, useRef } from 'react';
import { apiClient } from '../../services/api/client';

const EMPTY_BUCKETS = {
  tasks: [],
  staff: [],
  contacts: [],
  rooms: [],
  equipment: [],
  inventory_items: [],
  suppliers: [],
  procedures: [],
  roles: [],
};

export function useGlobalSearch(query, limit = 5) {
  const [buckets, setBuckets] = useState(EMPTY_BUCKETS);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  useEffect(() => {
    if (!query || query.length < 2) {
      setBuckets(EMPTY_BUCKETS);
      setIsLoading(false);
      return;
    }

    if (abortRef.current) {
      abortRef.current.abort();
    }
    const controller = new AbortController();
    abortRef.current = controller;

    setIsLoading(true);
    setError(null);

    apiClient
      .get('/api/v1/search/', {
        params: { q: query, limit },
        signal: controller.signal,
      })
      .then((response) => {
        setBuckets({ ...EMPTY_BUCKETS, ...(response.data?.data?.results ?? {}) });
      })
      .catch((err) => {
        if (err.name !== 'CanceledError' && err.code !== 'ERR_CANCELED') {
          setError(err.message);
          setBuckets(EMPTY_BUCKETS);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });

    return () => controller.abort();
  }, [query, limit]);

  const totalCount = Object.values(buckets).reduce((n, arr) => n + arr.length, 0);

  return { buckets, totalCount, isLoading, error };
}

export default useGlobalSearch;
